export const COLORS = [
  '#F44336',
  '#E91E63',
  '#673AB7',
  '#2196F3',
  '#8BC34A',
  '#FFC107',
  '#FF9800',
  '#FF5722',
];

export const CARD_MOVEMENT_DISTANCE = 200;
export const CARD_ROTATION_AMOUNT = 15;

// export const SCRIPT_PATH = 'script.json';

// Percentage Circle
export const MIN_PERCENTAGE = 0;
export const MAX_PERCENTAGE = 100;

// Mailchimp
export const mailchimpURL = 'https://wearesupportive.us18.list-manage.com/subscribe/post?u=40067302b02edea4063b16716&amp;id=7e19c9a7b6'




// WEBPACK FOOTER //
// ./src/constants.ts